<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss">
.cube-form {
  .cube-form-label {
    color: #333;
    width: 3rem;
  }
}

.title_ {
  font-size: 0.48rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  position: relative;
  text-align: left;
  padding: 0.33rem 0;
  padding-left: 20px;
  background: #f8f8f8;
  &::after {
    content: "";
    position: absolute;
    top: 33%;
    left: 0px;
    width: 0.07rem;
    height: 0.43rem;
    background: rgba(27, 124, 248, 1);
  }
}

.cube-upload-def .cube-upload-btn,
.cube-upload-def .cube-upload-file {
  border-radius: 10px;
}
.cube-upload-btn-def {
  background: #eee;
  border-radius: 10px;
}
.cube-upload-btn-def > span::before,
.cube-upload-btn-def > span::after {
  width: 36px;
  height: 5px;
  background-color: #d8d8d8;
  border-radius: 3px;
}
.cube-upload-btn {
}

input[type="checkbox"] {
  margin-right: 5px;
  cursor: pointer;
  font-size: 14px;
  // width: 15px;
  // height: 12px;
  position: relative;
}

input[type="checkbox"]:after {
  position: absolute;
  width: 10px;
  height: 15px;
  top: 0;
  content: " ";
  background-color: #fff;
  color: #fff;
  border: 1px solid #aaa;
  display: inline-block;
  visibility: visible;
  padding: 0px 2px;
  border-radius: 3px;
}

input[type="checkbox"]:checked:after {
  content: "✓";
  background-color: #0079fe;
  font-size: 12px;
}

input[type="radio"] {
  margin-right: 5px;
  cursor: pointer;
  font-size: 14px;
  width: 15px;
  height: 12px;
  position: relative;
}

input[type="radio"]:after {
  position: absolute;
  width: 10px;
  height: 15px;
  top: 0;
  content: " ";
  background-color: #fff;
  color: #fff;
  border: 1px solid #aaa;
  display: inline-block;
  visibility: visible;
  padding: 0px 3px;
  border-radius: 50%;
}

input[type="radio"]:checked:after {
  content: "✓";
  background-color: #0079fe;
  line-height: 0.4rem;
}
</style>
